// https://github.com/junipersquare/main/blob/a77563236ecb46391789352a10eb5714f860f708/jsq/client/src/common/utils/fieldUtils/index.ts
/**
 * Uses the same logic used by the BankAccountModel to redact an account number.
 * Returns a string with, at most, the last 4 digits of the account number.
 */
export const redactAccountNumber = (accountNumber: string): string => {
  const lenToShow = Math.min(Math.floor(accountNumber.length / 2), 4);
  return accountNumber.substring(accountNumber.length - lenToShow);
};
